import React from 'react';
import {useTranslation} from 'react-i18next';
import {ComputedPageItem} from '@taopix/taopix-core/dist/types/types';
import {HelpIcon} from '@taopix/taopix-design-system';
import ExperienceSettings from './ExperiencePalette';
import AssetsPalette from './AssetsPalette';
import classNames from 'classnames';
import {useUiState} from '../../Context/UserInterface/UserInterfaceContext';
import ToolPaletteSection from '../../ToolPalette/ToolPaletteSection';

export type DevPaletteProps = {
  sectionKey: string;
  item?: ComputedPageItem;
};

const DevPalette = ({sectionKey, item}: DevPaletteProps) => {
  const ui = useUiState();
  const {t} = useTranslation();

  const sectionButtonClasses = [
    ...(ui.state.isSmallScreen
      ? [
          'threeButtons:w-[calc(100vw/3.5)]',
          'fourButtons:w-[calc(100vw/4.5)]',
          'fiveButtons:w-[calc(100vw/5.5)]',
          'sixButtons:w-[calc(100vw/6.5)]',
          'sevenButtons:w-[calc(100vw/7.5)]',
          'eightButtons:w-[calc(100vw/8.5)]',
        ]
      : ['']),
  ];

  const wrapperClasses = classNames('flex', 'px-md', 'flex-col', 'space-y-xs', 'overflow-y-auto');

  return (
    <ToolPaletteSection
      buttonClasses={sectionButtonClasses.join(' ')}
      sectionKey={sectionKey}
      smallScreenPanelHeight="full"
      title={t('str_LabelDev')}
      buttonIcon={<HelpIcon />}
      id="devPalette"
    >
      <div className={wrapperClasses}>
        <ExperienceSettings sectionKey="experience" />
        <AssetsPalette sectionKey="assets" />
      </div>
    </ToolPaletteSection>
  );
};

export default DevPalette;
